;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:localcoin":true});}catch(e){}}();import { TFunction } from 'i18next';

import { FullDays, ShortDays } from '@/consts/dates';

import { LocationDetail } from '../types';
import { CLOSED } from './consts';
import { FormattedGroup, TimeSlot } from './types';

const formatTimeSlot = (open: string, close: string): string => {
  if (open === '12:00 AM' && close === '12:00 AM') {
    return '24h';
  }

  return open === CLOSED ? CLOSED : `${open} - ${close}`;
};

const formatGroup = (days: string[], timeSlot: TimeSlot, t: TFunction): FormattedGroup => {
  const timeSlotString = formatTimeSlot(timeSlot.open, timeSlot.close);

  if (days.length === 1) {
    const day = days[0];
    const dayKey = day.toLowerCase();

    return { days: t(`dates.shortDays.${dayKey}`, day), timeSlot: timeSlotString };
  }

  if (days.length === 7) {
    return { days: t('dates.monSun'), timeSlot: timeSlotString };
  }

  const firstDay = t(`dates.shortDays.${days[0].toLowerCase()}`, days[0]);
  const lastDay = t(
    `dates.shortDays.${days[days.length - 1].toLowerCase()}`,
    days[days.length - 1],
  );

  return { days: `${firstDay}-${lastDay}`, timeSlot: timeSlotString };
};

const getDailyHours = (locationDetails: LocationDetail): Record<string, TimeSlot> => ({
  Mon: {
    open: locationDetails.mondayOpenHour ?? CLOSED,
    close: locationDetails.mondayCloseHour ?? CLOSED,
  },
  Tue: {
    open: locationDetails.tuesdayOpenHour ?? CLOSED,
    close: locationDetails.tuesdayCloseHour ?? CLOSED,
  },
  Wed: {
    open: locationDetails.wednesdayOpenHour ?? CLOSED,
    close: locationDetails.wednesdayCloseHour ?? CLOSED,
  },
  Thu: {
    open: locationDetails.thursdayOpenHour ?? CLOSED,
    close: locationDetails.thursdayCloseHour ?? CLOSED,
  },
  Fri: {
    open: locationDetails.fridayOpenHour ?? CLOSED,
    close: locationDetails.fridayCloseHour ?? CLOSED,
  },
  Sat: {
    open: locationDetails.saturdayOpenHour ?? CLOSED,
    close: locationDetails.saturdayCloseHour ?? CLOSED,
  },
  Sun: {
    open: locationDetails.sundayOpenHour ?? CLOSED,
    close: locationDetails.sundayCloseHour ?? CLOSED,
  },
});

export const getOpenHours = (locationDetails: LocationDetail, t: TFunction): FormattedGroup[] => {
  if (checkIf24HoursAllWeek(locationDetails)) {
    return [{ days: t('dates.monSun'), timeSlot: '24/7' }];
  }

  const hours = getDailyHours(locationDetails);
  const result: FormattedGroup[] = [];
  let currentGroup: string[] = [];
  let lastTimeSlot: TimeSlot = { open: '', close: '' };

  ShortDays.forEach((day) => {
    const { open, close } = hours[day];

    if (open === lastTimeSlot.open && close === lastTimeSlot.close) {
      currentGroup.push(day);
    } else {
      if (currentGroup.length) {
        result.push(formatGroup(currentGroup, lastTimeSlot, t));
      }

      currentGroup = [day];
      lastTimeSlot = { open, close };
    }
  });

  if (currentGroup.length) {
    result.push(formatGroup(currentGroup, lastTimeSlot, t));
  }

  return result;
};

export const parseTime = (time: string) => {
  const [hours] = time.match(/\d+/g)?.map(Number) || [0, 0];

  return time.includes('PM') && hours !== 12 ? hours + 12 : hours;
};

export const checkIf24HoursAllWeek = (locationDetails: LocationDetail) => {
  return FullDays.every((day) => {
    const openHour = locationDetails[`${day}OpenHour`];
    const closeHour = locationDetails[`${day}CloseHour`];

    return (
      (openHour === '12:00 PM' && closeHour === '12:00 PM') ||
      (openHour === '12:00 AM' && closeHour === '12:00 AM') ||
      (openHour === '12:00 AM' && closeHour === '12:00 PM') ||
      (openHour === '12:00 PM' && closeHour === '12:00 AM')
    );
  });
};

export const checkIfOpenNow = (locationDetails: LocationDetail) => {
  const currentDay = FullDays[new Date().getDay()];
  const currentTime = new Date().getHours();

  if (!locationDetails[`${currentDay}OpenHour`] || !locationDetails[`${currentDay}CloseHour`]) {
    return false;
  }

  const openHour = parseTime(locationDetails[`${currentDay}OpenHour`] || '');
  const closeHour = parseTime(locationDetails[`${currentDay}CloseHour`] || '');

  return currentTime >= openHour && currentTime < closeHour;
};
